import SVG from "@/app/components/pages/SVG";
import { LOGO_LISTS } from "@/app/utils/constants/constants";
import { slice } from "lodash";

const LogoLists = () => {
  return (
    <div className="flex flex-wrap p-5 md:justify-between lg:py-14">
      {slice(LOGO_LISTS, 0, 4).map((img, index) => (
        <div
          className="flex items-center justify-center w-1/4 px-2 md:w-[14.2%] lg:w-auto"
          key={index}
        >
          <div className="w-full flex items-center justify-center md:h-24">
            <SVG
              alt={img.alt || "Logo"}
              src={img.src}
              twClasses="object-contain max-w-full max-h-full"
              width={img.width || 94}
              height={img.height || 94}
            />
          </div>
        </div>
      ))}
      {slice(LOGO_LISTS, 4).map((img, index) => (
        <div
          className="flex items-center justify-center w-1/3 px-4 md:w-[14.2%] lg:w-auto"
          key={index}
        >
          <div className="w-full flex items-center justify-center md:h-24">
            <SVG
              alt={img.alt || "Logo"}
              src={img.src}
              twClasses="object-contain max-w-full max-h-full"
              width={img.width || 94}
              height={img.height || 26}
            />
          </div>
        </div>
      ))}
    </div>
  );
};

export default LogoLists;
